import { Typography } from "@mui/material";
import type { FC } from "react";
import EntityCard from "../../components/entityCard/EntityCard";
import type { Note } from "../../components/notes/Notes";
import SimpleNotes from "../../components/notes/SimpleNotes";
import { useUpdateAgentNotes } from "./useUpdateAgentNotes";
import { LastNotes } from "../../components/entityCard/LastNotes";

interface Agent {
  readonly id: string;
  readonly name: string;
  readonly notes: Note[];
}

interface Props {
  readonly value: Agent;
  readonly onClick: () => void;
  readonly onContextMenu: () => void;
}

const AgentCard: FC<Props> = ({ value, onClick, onContextMenu }) => {
  const { updateNotes: updateNotes } = useUpdateAgentNotes(value.id);
  return (
    <EntityCard
      role="ADMIN"
      onClick={onClick}
      onContextMenu={onContextMenu}
      rightHandSideComponent={<LastNotes notes={value.notes} />}
      rightHandSideComponentExpandable
      rightHandSideComponentSize={6}
      expandableComponent={
        <SimpleNotes
          notes={value.notes}
          onChange={async (notes) => {
            await updateNotes(notes);
          }}
        />
      }
    >
      <Typography variant="subtitle1">{value.name}</Typography>
    </EntityCard>
  );
};

export default AgentCard;
